import React from 'react';
import { Stack } from '@mui/material';
import { TotalPMsCard, ComplianceRateCard, OverduePMsCard, TotalPMCostCard } from '../../charts';
import { PMReportSummaryView } from '../../../../../services/ReportingService';

interface PMReportSummaryCardsProps {
  summaryData: PMReportSummaryView;
}

const PMReportSummaryCards: React.FC<PMReportSummaryCardsProps> = ({ summaryData }) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{ maxWidth: 1200, mx: 'auto' }}
    >
      <TotalPMsCard value={summaryData.totalPMs} />
      <ComplianceRateCard value={summaryData.complianceRate} />
      <OverduePMsCard value={summaryData.overdue} />
      <TotalPMCostCard value={summaryData.totalCost} />
    </Stack>
  );
};

export default PMReportSummaryCards;
